import React from 'react';
import PropTypes from 'prop-types';
import { Image, AmpImage } from '@apmg/mimas';
import Link from 'components/AppSafeLink/AppSafeLink';

const ampStyles = {
  figure: {
    fontFamily: '"Roboto", system-ui, -apple-system, sans-serif',
    fontSize: '0.85em',
    lineHeight: '1.2',
    padding: '1em 0',
  },
  text: {
    display: 'inline',
    paddingRight: '1em',
  },
  credit: {
    display: 'inline-block',
    color: '#4a4e4f',
  },
};

const ApmImageOverride = (props) => {
  if (props.minimal) {
    return null;
  }

  function classes() {
    const position = props?.image?.float ? `figure-${props.image.float}` : '';
    const size = `figure-${props?.image?.width ? props.image.width : 'full'}`;
    return `figure ${position} ${size}`;
  }

  function captionCredit() {
    if (props?.image?.credit && props.image.credit_url) {
      return (
        <Link href={props.image.credit_url} className="figure_credit">
          {props.image.credit}
        </Link>
      );
    } else if (props?.image?.credit) {
      return <div className="figure_credit">{props.image.credit}</div>;
    }
  }

  function ampCaptionCredit() {
    if (image?.credit && image.credit_url) {
      return (
        <Link
          style={ampStyles.credit}
          href={image.credit_url}
          className="figure_credit"
        >
          {image.credit}
        </Link>
      );
    } else if (image?.credit) {
      return (
        <div style={ampStyles.credit} className="figure_credit">
          {image.credit}
        </div>
      );
    }
  }

  function image(embedded, isAmp = false) {
    const embeddedImage = embedded?.images?.find(
      (image) => image?.id && image?.id === props?.image?.id
    );

    if (!embeddedImage || embeddedImage.status === 'unpublished') {
      return null;
    }

    if (isAmp) {
      return (
        <AmpImage
          image={embeddedImage}
          aspectRatio={props?.image?.preferred_aspect_ratio_slug}
          sizes="(max-width: 47.999em) 99vw, 66vw"
        />
      );
    }

    return (
      <Image
        image={embeddedImage}
        aspectRatio={props?.image?.preferred_aspect_ratio_slug}
        sizes="(max-width: 47.999em) 99vw, 66vw"
      />
    );
  }

  const img = image(props.embedded, props.isAmp);
  if (!img) {
    return null;
  }

  return (
    <figure className={classes()}>
      {img}
      {props?.image?.long_caption || props?.image?.credit ? (
        <figcaption className="figure_caption">
          {props.image.long_caption && (
            <div className="figure_text">{props.image.long_caption}</div>
          )}
          {props.isAmp ? ampCaptionCredit() : captionCredit()}
        </figcaption>
      ) : (
        ''
      )}
    </figure>
  );
};

ApmImageOverride.propTypes = {
  image: PropTypes.object,
  embedded: PropTypes.object,
  minimal: PropTypes.bool,
  isAmp: PropTypes.bool, // for AMP html
};

export default ApmImageOverride;
